import { cn } from "@/lib/utils";

export function BrandWordmark({ className }: { className?: string }) {
  return (
    <img
      className={cn("brand-wordmark block h-auto w-40", className)}
      src="/brand/roofseye-wordmark.png"
      alt="RoofsEye"
      width="1200"
      height="250"
      draggable="false"
    />
  );
}
